import React from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import InvoiceForm from "./form";

export default function InvoiceUpdate() {
  const { id } = useParams();
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Invoices", path: "/billing/invoices" },
          { label: "Edit", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <FileTextOutlined /> }}
        title="Edit Invoice"
        style={{ marginBottom: 16 }}
      />
      <InvoiceForm id={id} />
    </div>
  );
}
